import Player from "./player";
import Enemy from "./enemy";

export default class Barrel extends Phaser.GameObjects.Image {
    private _recoil: boolean;
    private _recoilTween: Phaser.Tweens.Tween;
    private _parent: Player | Enemy;
    private _offset: { x: number, y: number };
    private _recoilLimit: number = 0;
    public tag: string;
    constructor(scene: Phaser.Scene, x: number, y: number, key: string, frame: string, recoil: boolean, parent: Player | Enemy, colliderData, recoilLimit?: number) {
        super(scene, x, y, key, frame);
        this.tag = frame;
        // this.setOrigin(colliderData.cx, colliderData.cy);
        this._recoil = recoil;
        this._parent = parent;
        this.scene.add.existing(this);
        this._offset = {
            x: x, y: y
        };
        if(this._recoil) {
            this._recoilLimit = recoilLimit;
        }
        this.stop();
    }

    update(time, dt) {
        if(!this._recoil) {
            this.setPosition(this._parent.x + this._offset.x, this._parent.y + this._offset.y);
        }
    }

    public start(startRecoil?: boolean) {
        this.setActive(true);
        this.setVisible(true);
        this.setPosition(this._offset.x, this._offset.y);
        if (startRecoil == true) {
            this.startRecoil();
        }
    }

    public startRecoil() {
        if (this._recoil) {
            this.stopRecoil();
            this._recoilTween = this.scene.add.tween({
                targets: this,
                callbackScope: this,
                y: '-='+this._recoilLimit,
                ease: 'Linear',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
                duration: 100,
                repeat: -1,            // -1: infinity
                yoyo: true
            })
        }
    }

    public stopRecoil() {
        if(this._recoil && this._recoilTween){
            this._recoilTween.stop();
            this.scene.tweens.remove(this._recoilTween);
        }
    }

    public stop() {
        this.setActive(false);
        this.setVisible(false);
        this.stopRecoil();

    }

    public turn(rad) {
        this.rotation = rad;
    }
}